/**
 * Webpack's RequireModule type definition.
 * It is used to require modules dynamically based on their directory and regular expression.
 */
type RequireModule = {
    (id: string): any;
    keys(): string[];
};

/**
 * Webpack's require context type definition.
 * This is used to load modules from the src/ directory.
 */
declare const require: {
    context(directory: string, useSubdirectories: boolean, regExp: RegExp): RequireModule;
};

/** Initialize domain by calling their init.ts files. */
function initDomains(): void {
    // load modules directly under src/ (not src/Modules/)
    const requireModule = require.context(
        "@", // search from src root
        true, // include subdirectories
        /^\.\/[^/]+\/init.ts$/ // only init files in direct child directories
    );

    for (const key of requireModule.keys())
        requireModule(key);
}

export { initDomains };
